var change = "Cambiar";
var edit = "Editar";
var loading = "Cargando";
var logout = "Cerrar sesión";
var support = "Ayuda Online";
var more = "Más";
var yes = "Sí";
var no = "No";
var exit = "Salida";
var you = "Tú";
var search = "Buscar";
var es = {
	"business-unit": "Unidad de negocio",
	"ces-administration": "Administración del CES",
	change: change,
	"change-business-unit": "Cambiar unidad de negocio",
	edit: edit,
	loading: loading,
	logout: logout,
	"no-application-available": "No hay aplicación disponible.",
	"select-a-business-unit-to-change": "Seleccione una unidad de negocio a la que cambiar. Si la unidad comercial no utiliza su aplicación actual, se le llevará a su perfil.",
	support: support,
	"system-administration": "Administracion del sistema",
	more: more,
	yes: yes,
	no: no,
	"you-already-switched-to": "Ya te cambiaste a <bold>{{name}}</bold> hace un tiempo. ¿Quieres cambiar <bold>{{name}}</bold> aquí?",
	"business-unit-has-changed": "La unidad de negocio ha cambiado",
	exit: exit,
	"impersonated-user": "Usuario suplantado",
	you: you,
	"no-business-unit-assigned": "No hay unidad de negocio asignada",
	"explore-marigold": "Explorar Marigold",
	"no-data-to-display": "no hay información para mostrar",
	search: search
};

export { change, es as default, edit, exit, loading, logout, more, no, search, support, yes, you };
